/**
 * KLOTHOS Custom Events — GA4
 * Versión: 1.0.0 | Fecha: 04/04/2026
 * Eventos: verifica_lote | toggle_registro_sanitario | click_biblioteca
 *
 * Requiere: gtag() disponible globalmente (cargado via Google Tag G-LVY3EM12QH)
 */

(function() {
  'use strict';

  function waitForGtag(callback, maxAttempts) {
    var attempts = 0;
    var maxAtt = maxAttempts || 20;
    var interval = setInterval(function() {
      attempts++;
      if (typeof gtag === 'function') {
        clearInterval(interval);
        callback();
      } else if (attempts >= maxAtt) {
        clearInterval(interval);
      }
    }, 250);
  }

  function fireEvent(eventName, params) {
    if (typeof gtag === 'function') {
      gtag('event', eventName, params || {});
    }
  }

  // ─── EVENTO 1: verifica_lote ───
  // Dispara cuando el usuario envía el formulario en /pages/verifica-tu-lote
  // Selectores reales: form.kl-verifica__form, #kl-lote-input
  function initVerificaLote() {
    var form = document.querySelector('form.kl-verifica__form') ||
               document.getElementById('kl-verifica-form');
    if (!form) return;

    var input = document.getElementById('kl-lote-input') ||
                form.querySelector('input[type="text"]');

    form.addEventListener('submit', function() {
      var loteValue = input ? (input.value || '').trim() : '';
      fireEvent('verifica_lote', {
        lote_codigo: loteValue || 'no_especificado',
        page_location: window.location.href
      });
    });
  }

  // ─── EVENTO 2: toggle_registro_sanitario ───
  // Dispara cuando el usuario abre el toggle del registro en Home
  // Selector real: button#kl-registro-btn (aria-expanded toggle)
  function initToggleRegistro() {
    var btn = document.getElementById('kl-registro-btn');
    if (!btn) return;

    var tracked = false;
    btn.addEventListener('click', function() {
      var wasExpanded = btn.getAttribute('aria-expanded') === 'true';
      // Solo trackear cuando se ABRE (wasExpanded es el estado ANTES del click
      // pero el handler nativo ya lo cambió, así que chequeamos el estado actual)
      if (!tracked) {
        tracked = true;
        fireEvent('toggle_registro_sanitario', {
          action: wasExpanded ? 'close' : 'open',
          page_location: window.location.href
        });
        setTimeout(function() { tracked = false; }, 2000);
      }
    });
  }

  // ─── EVENTO 3: click_biblioteca ───
  // Dispara cuando el usuario hace clic en un artículo de la Biblioteca
  // Selectores reales: .kl-bib3 (Home), .kl-biblioteca-home (hub)
  function initClickBiblioteca() {
    // Delegación en document para capturar links de biblioteca en cualquier página
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a.kl-bib3__titulo') ||
                 e.target.closest('a.kl-bib3__cta') ||
                 e.target.closest('.kl-biblioteca-home a[href*="biblioteca"]') ||
                 e.target.closest('a[href*="biblioteca-de-evidencia"]') ||
                 e.target.closest('a[href*="biblioteca-articulo"]') ||
                 e.target.closest('a[href*="biblioteca-ficha"]');
      if (!link) return;

      var titleEl = link.querySelector('h2, h3, h4');
      var titulo = titleEl
        ? titleEl.textContent.trim().substring(0, 80)
        : link.textContent.trim().substring(0, 80);

      fireEvent('click_biblioteca', {
        articulo_titulo: titulo || 'desconocido',
        articulo_url: link.href,
        page_location: window.location.href
      });
    });
  }

  // ─── INIT ───
  function init() {
    initVerificaLote();
    initToggleRegistro();
    initClickBiblioteca();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      waitForGtag(init);
    });
  } else {
    waitForGtag(init);
  }

})();
